module.exports = __webpack_public_path__ + "static/home-1-1-phone-bf200d086ca9134abf28887e72fadf94.png";